import React, { useEffect, useRef, useState } from 'react';

const UserMenu = ({ handleLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const storedName = localStorage.getItem('name') || 'User';
  const storedEmail = localStorage.getItem('email') || 'unknown';

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div
      className="headerRight"
      ref={menuRef}
      onClick={toggleDropdown}
      style={{ display: 'flex', alignItems: 'center', position: 'relative', cursor: 'pointer' }}
    >
      {/* Profile Picture */}

      {/* <div className="profilePic">
              <div 
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: '#1C8F7D',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
            userSelect: 'none',
            cursor: 'pointer'
          }}
          aria-label="User Initial"
          title={storedEmail}
        >
          {storedName.charAt(0).toUpperCase()}
        </div>
        
      </div> */}

      {/* Hamburger / Close Icon */}
      <div className={`hamburger ${isOpen ? 'active' : ''}`}>
        <div className="line line-1"></div>
        <div className="line line-2"></div>
        <div className="line line-3"></div>
     </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div
          className="nav-links active"
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '12px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            zIndex: 10001,
            padding: '1rem',
          }}
        >
          <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            <li><a href="/dashboard">Home</a></li>
            {/* <li><a href="/points">Home</a></li> */}
            {/* <li><a href="/manage">Manage</a></li> */}
            <li><a href="/manage">Profile</a></li>
            <li><a href="/change-password">Password</a></li>
            <li><a href="#">Notifications</a></li>
            <li>
              <a href="#" onClick={(e) => { e.stopPropagation(); handleLogout(); }}>
                Logout
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
